// extracted by mini-css-extract-plugin
module.exports = {"heading":"jobs_heading__9h6x-","content":"jobs_content__2VHkF","button":"jobs_button__cpgr1","sending":"jobs_sending__Fzbs6"};